export default "__VITE_ASSET__30f19274__"